import React from 'react';

import DigitalRetailOverlayCTA from '../DigitalRetailOverlayCTA';

function DealCardDeepLink({ vehicle, onSDPError, uiContext = 'dealPanel', ...rest }) {
    return (
        <DigitalRetailOverlayCTA
            listedPrice={vehicle.sellingPrice}
            listing={vehicle}
            onError={onSDPError}
            uiContext={uiContext}
            {...rest}
        />
    );
}

export default DealCardDeepLink;
